import { formatDate, getTime } from '@/__core__/components/headers/common-header/CommonHeader.helpers'
import { loc } from '@/__core__/localization/localization'

export function getAdjustedEvent(langId) {
  return event => {
    const [homeTeam, awayTeam] = event.teams || [null, null]

    const startTime = new Date(event.startTime)
    const upcoming = Date.now() < startTime.getTime()
    const hasPenalties = homeTeam && awayTeam && ![undefined, null].includes(homeTeam.penaltyScore) && ![undefined, null].includes(awayTeam.penaltyScore)

    let timeStatus
    let outcome

    if (event.ended) {
      const EventTimeStatusLookup = {
        [loc('sm_full_time_short', langId)]: {
          timeStatus: loc('sm_full_time', langId),
          outcome: ''
        },

        [loc('sm_ap', langId)]: {
          timeStatus: loc('sm_full_time', langId),
          outcome: event.timeStatus
        },

        [loc('sm_aet', langId)]: {
          timeStatus: loc('sm_full_time', langId),
          outcome: event.timeStatus
        }
      }

      timeStatus = EventTimeStatusLookup[event.timeStatus].timeStatus
      outcome = EventTimeStatusLookup[event.timeStatus].outcome
    } else if (upcoming) {
      timeStatus = getTime(startTime)
      outcome = ''
    } else {
      timeStatus = loc('sm_live', langId)
      outcome = ''
    }

    /* necessary because vendor doesn't provide AP status always, instead they provide FT */
    if (hasPenalties && timeStatus !== loc('sm_ap', langId)) {
      outcome = loc('sm_ap', langId)
    }

    return {
      ...event,
      upcoming,
      timeStatus,
      outcome,
      hasPenalties,
      startDate: formatDate(startTime, langId, 'DD_num MM_short'),
      teams: event.teams?.map(team => ({ ...team, score: getTeamScore(team.score) }))
    }
  }
}

function getTeamScore(score) {
  if (score !== 0 && !score) {
    return '-'
  }

  return `${score}`
}
